'use client';

import UnstyledAccordion from '@/components/UnstyledAccordion';
import UnstyledAccordionItem from '@/components/UnstyledAccordion/UnstyledAccordion.Item';
import UnstyledAccordionItemBody from '@/components/UnstyledAccordion/UnstyledAccordion.ItemBody';
import UnstyledAccordionItemCaret from '@/components/UnstyledAccordion/UnstyledAccordion.ItemCaret';
import UnstyledAccordionItemHandle from '@/components/UnstyledAccordion/UnstyledAccordion.ItemHandle';
import UnstyledAccordionItemLabel from '@/components/UnstyledAccordion/UnstyledAccordion.ItemLabel';
import { useCategoryChoice } from '@liquorice/next-search';
import Checkboxes, { CheckboxesProps } from './Checkboxes';

export interface CategoryFilterProps {
  filters: CheckboxesProps[];
}

const CategoryFilter = ({ filters }: CategoryFilterProps) => {
  return (
    <UnstyledAccordion>
      {filters.map((filter, index) => {
        const { options } = useCategoryChoice(filter);
        if (!options || options.length === 0) return null;

        return (
          <UnstyledAccordionItem key={index} index={index}>
            <UnstyledAccordionItemHandle index={index}>
              <UnstyledAccordionItemLabel
                underline="none"
                weight="bold"
                color="black"
                variant="text">
                {filter.label}
              </UnstyledAccordionItemLabel>
              <UnstyledAccordionItemCaret index={index} />
            </UnstyledAccordionItemHandle>
            <UnstyledAccordionItemBody index={index}>
              <Checkboxes {...filter} />
            </UnstyledAccordionItemBody>
          </UnstyledAccordionItem>
        );
      })}
    </UnstyledAccordion>
  );
};

export default CategoryFilter;
